import './App.css';
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import {Navigate, Route, Routes, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {ChatRecorder} from "./pages/chat-recorder/ChatRecorder";
import {HomePage} from "./pages/home-page/HomePage";
import {NotFound} from "./pages/not-found/NotFound";
import {MainLayout} from "./layouts/main/MainLayout";
import {FlowPage} from "./pages/flow/flow-page";
import {ChatPreview} from "./pages/chat-preview/ChatPreview";
import {ChatbotConversation} from "./pages/chatbot/ChatbotConversation";
import {LoadingScreen} from "./components/LoadingScreen";
import {AUTH_TOKEN} from "./axios/axios";

const darkTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      // default: "#212121"
    },
    light: {
      main: "#FFF"
    },
    primary: {
      main: "rgba(132, 145, 247, 1)"
    },
    dark: {
      main: "#2C2B2A"
    },
    secondary: {
      main: "#D7E8F4"
    }
  },
});

function App() {
  let [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const authToken = searchParams.get("auth")
  const conversation_logger = searchParams.get("conversation_logger")
  const flowUid = searchParams.get("flowUid");
  const json = searchParams.get("json_url")

  useEffect(() => {
    let url = process.env.REACT_APP_GATEWAY;
    if (conversation_logger) {
      url = atob(conversation_logger);
      console.log("Conversation Logger", url);
      if (localStorage.getItem("conversation_logger") !== url) {
        localStorage.setItem("conversation_logger", url);
        window.location.reload()
      }
    }
    if (authToken) {
      localStorage.setItem(AUTH_TOKEN, authToken)
    }

    setLoading(false);
    if (flowUid) {
      localStorage.setItem("flow_uid", flowUid);
      localStorage.removeItem("json_url");
      // navigate("/");
    }
    if (json) {
      // Decode the base64-encoded URL
      const decodedUrl = atob(json);
      setLoading(false);

      // Save the decoded URL to localStorage
      localStorage.setItem("json_url", decodedUrl);
    } else {
      console.log("json_url not found in searchParams");
    }
  }, [authToken, conversation_logger, flowUid, json]);


  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline/>
      <ToastContainer
        position={"top-right"}
        autoClose={2000}
        hideProgressBar
        newestOnTop
      />
      {(loading || !authToken) ?
        <LoadingScreen/>
        :
        null
      }
      <Routes>
        {/*<Route path={"/chat/:chatId"} element={<ChatRecorder asriId={null}/>}/>*/}
        <Route path={"/chat/:chatId/preview"} index element={<ChatPreview asriId={null}/>}/>
        <Route path={`/project/:flowUid/chatbot`} index element={<ChatbotConversation/>}/>
        <Route path={`/project/:flowUid/chatbot/:chatId`} index element={<ChatbotConversation/>}/>
        <Route path={"/flow/:flowUid/chat/:chatId"} index element={<ChatRecorder asriId={null}/>}/>
        <Route path={"/flow/:flowUid"} index element={<FlowPage asriId={null}/>}/>
        <Route path={"/not-found"} element={<MainLayout><NotFound/></MainLayout>}/>
        <Route path={"/"} index element={<HomePage/>}/>
        <Route path={"*"} element={<Navigate to={"/not-found"}/>}/>
      </Routes>


    </ThemeProvider>
  );
}

export default App;
